export default __webpack_public_path__ + "static/media/sandbox1.65ae7f75.png";